import React from 'react'
import { IEpiProps, StepConstants } from '../models/event-reg-refresh-models'
import { useEventRegRefreshContext } from '../reducers/event-reg-refresh-reducers'
import { MainContent } from './layout/main-content'
import { ContentWrapper } from './layout/content-wrapper'

interface IContextProps {
  epiProps: IEpiProps
  currentStep: string
}

export const DesignSystem = () => {
  const { currentStep }: IContextProps = useEventRegRefreshContext()!

  if (currentStep == "DesignSystem") {
    return (
      <ContentWrapper>
        <MainContent>
          <div className="alert alert-error">
            <svg className="svg-icon" aria-hidden="true" focusable="false">
              <use xmlnsXlink="ttp://www.w3.org/2000/xlink" xlinkHref="#alert-icon" />
            </svg>
            <div className="alert-inner">
              {children}
            </div>
          </div>
        <h1>Heading 1 — The quick brown fox jumps over the lazy dog 0123456789</h1>
        <h2>Heading 2 — The quick brown fox jumps over the lazy dog 0123456789</h2>
        <h3>Heading 3 — The quick brown fox jumps over the lazy dog 0123456789</h3>
        <h4>Heading 4 — The quick brown fox jumps over the lazy dog 0123456789</h4>
        <h5>Heading 5 — The quick brown fox jumps over the lazy dog 0123456789</h5>
        <h6>Heading 6 — The quick brown fox jumps over the lazy dog 0123456789</h6>

        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer sit amet
          arcu nec libero luctus ultricies eget non neque. Curabitur et sapien ac
          urna blandit interdum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer sit amet
          arcu nec libero luctus ultricies eget non neque. Curabitur et sapien ac
          urna blandit interdum.
        </p>

        <p class="large">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
          scelerisque, magna ut facilisis mattis, orci arcu pulvinar metus, sed
          cursus felis leo non tellus. Suspendisse potenti. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer sit amet
          arcu nec libero luctus ultricies eget non neque. Curabitur et sapien ac
          urna blandit interdum.
        </p>

        <p class="small">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vitae
          consequat neque. Sed non risus at massa ultricies viverra. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer sit amet
          arcu nec libero luctus ultricies eget non neque. Curabitur et sapien ac
          urna blandit interdum.
          </p>
          <button className="btn-primary">Button</button>
          <button className="btn-secondary">Button</button>
          <button className="btn-tertiary">Button</button>
          <div className="rich-text">
            <h1>Welcome to Our Sample Website</h1>
            <h2>About Our Services</h2>
            <h3>What We Offer</h3>
            <h4>Quality Assurance</h4>
            <h5>Customer Support</h5>
            <h6>Additional Information</h6>

            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>

            <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt.</p>

            <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.</p>

            <p>Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet.</p>

            <h3>Our Features (Unordered List)</h3>
            <ul>
              <li>Fast and reliable service</li>
              <li>24/7 customer support</li>
              <li>Secure payment processing</li>
              <li>Free shipping on orders over $50</li>
              <li>30-day money-back guarantee</li>
              <li>Mobile-friendly interface</li>
            </ul>

            <h3>Steps to Get Started (Ordered List)</h3>
            <ol>
              <li>Create your account by clicking the sign-up button</li>
              <li>Verify your email address</li>
              <li>Complete your profile information</li>
              <li>Browse our product catalog</li>
              <li>Add items to your cart</li>
              <li>Proceed to checkout</li>
              <li>Enter payment and shipping details</li>
              <li>Confirm your order</li>
            </ol>
          </div>
        </MainContent>
      </ContentWrapper>
    )
  }
}
